__webpack_require__.S = {};
var initPromises = {};
var initTokens = {};
__webpack_require__.I = (name, initScope) => {
	if(!initScope) initScope = [];
	// handling circular init calls
	var initToken = initTokens[name];
	if(!initToken) initToken = initTokens[name] = {};
	if(initScope.indexOf(initToken) >= 0) return;
	initScope.push(initToken);
	// only runs once
	if(initPromises[name]) return initPromises[name];
	// creates a new share scope if needed
	if(!__webpack_require__.o(__webpack_require__.S, name)) __webpack_require__.S[name] = {};
	// runs all init snippets from all modules reachable
	var scope = __webpack_require__.S[name];
	var warn = (msg) => {
		if (typeof console !== "undefined" && console.warn) console.warn(msg);
	};
	var uniqueName = "refinity";
	var register = (name, version, factory, eager) => {
		var versions = scope[name] = scope[name] || {};
		var activeVersion = versions[version];
		if(!activeVersion || (!activeVersion.loaded && (!eager != !activeVersion.eager ? eager : uniqueName > activeVersion.from))) versions[version] = { get: factory, from: uniqueName, eager: !!eager };
	};
	var initExternal = (id) => {
		var handleError = (err) => (warn("Initialization of sharing external failed: " + err));
		try {
			var module = __webpack_require__(id);
			if(!module) return;
			var initFn = (module) => (module && module.init && module.init(__webpack_require__.S[name], initScope))
			if(module.then) return promises.push(module.then(initFn, handleError));
			var initResult = initFn(module);
			if(initResult && initResult.then) return promises.push(initResult['catch'](handleError));
		} catch(err) { handleError(err); }
	}
	var promises = [];
	switch(name) {
		case "default": {
			register("@angular/common/http", "21.2.11", () => (Promise.all([__webpack_require__.e(1198), __webpack_require__.e(7106), __webpack_require__.e(6613), __webpack_require__.e(4285)]).then(() => (() => (__webpack_require__(16613))))));
			register("@angular/common", "21.2.11", () => (Promise.all([__webpack_require__.e(7106), __webpack_require__.e(1352), __webpack_require__.e(5534)]).then(() => (() => (__webpack_require__(21352))))));
			register("@angular/core/primitives/di", "21.2.11", () => (Promise.all([__webpack_require__.e(2076), __webpack_require__.e(8330)]).then(() => (() => (__webpack_require__(8513))))));
			register("@angular/core/primitives/signals", "21.2.11", () => (Promise.all([__webpack_require__.e(2076), __webpack_require__.e(4334)]).then(() => (() => (__webpack_require__(36699))))));
			register("@angular/core/rxjs-interop", "21.2.11", () => (Promise.all([__webpack_require__.e(2260), __webpack_require__.e(1198), __webpack_require__.e(2076), __webpack_require__.e(4680)]).then(() => (() => (__webpack_require__(49074))))));
			register("@angular/core", "21.2.11", () => (Promise.all([__webpack_require__.e(2260), __webpack_require__.e(352), __webpack_require__.e(5753)]).then(() => (() => (__webpack_require__(49460))))));
			register("@angular/router", "21.2.11", () => (Promise.all([__webpack_require__.e(1198), __webpack_require__.e(7106), __webpack_require__.e(8745), __webpack_require__.e(4665)]).then(() => (() => (__webpack_require__(38745))))));
		}
		break;
	}
	if(!promises.length) return initPromises[name] = 1;
	return initPromises[name] = Promise.all(promises).then(() => (initPromises[name] = 1));
};